import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { addpromotionalAddonPlan, logOutApi } from '../../../Context/api';
import { promotionalPlanValidation } from '../../../Context/validation';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UseAddPromotionalAddon = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId,userId:adminData.userId,type:'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const messagePlanAdd = useFormik({
        initialValues: {
                planName:'',
                description:'',
                credit:'',
                price:''
        },
        validationSchema: promotionalPlanValidation,
        
        onSubmit: (values) => {

            const data = {

                name: values.planName.trim(),
                description: values.description.trim(),
                credit: values.credit,
                price: values.price,
            }
            setSpinner(true)

            console.log(data,"datadata")

            axios.post(addpromotionalAddonPlan(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    messagePlanAdd.resetForm()
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })
        }
    })
  return {
    spinner,
    messagePlanAdd
  }
}

export default UseAddPromotionalAddon